import axios from './axios-auth';

const getMe = () =>
  new Promise((resolve, reject) => {
    axios({
      url: '/me',
      method: 'GET',
    })
      .then((resp) => {
        // const user = {
        //   id: resp.data.id,
        //   username: resp.data.username,
        //   firstName: resp.data.firstName,
        //   lastName: resp.data.lastName,
        //   email: resp.data.email,
        //   address1: resp.data.address1,
        //   address2: resp.data.address2,
        //   city: resp.data.city,
        //   state: resp.data.state,
        //   zip: resp.data.zip,
        //   dayPhone: resp.data.dayPhone,
        //   eveningPhone: resp.data.eveningPhone,
        //   residenceCountry: resp.data.residenceCountry,
        //   pointsAvailable: resp.data.pointsAvailable,
        //   isAdmin: resp.data.isAdmin,
        // };
        resolve(resp.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

const getAdminUser = () =>
  new Promise((resolve, reject) => {
    axios({
      url: '/dv-adm/getmydetails',
      method: 'GET',
    })
      .then((resp) => {
        const user = {
          id: resp.data.id,
          username: resp.data.username,
          firstName: resp.data.full_name,
          lastName: resp.data.lastName,
          email: resp.data.email,
          address1: resp.data.address1,
          address2: resp.data.address2,
          city: resp.data.city,
          state: resp.data.state,
          zip: resp.data.zip,
          dayPhone: resp.data.dayPhone,
          eveningPhone: resp.data.eveningPhone,
          residenceCountry: resp.data.residenceCountry,
          pointsAvailable: resp.data.pointsAvailable,
          isAdmin: resp.data.isAdmin,
        };
        console.log(user, 'from get admin user api');
        resolve(user);
      })
      .catch((err) => {
        reject(err);
      });
  });

const patchMe = (id, firstName, lastName, email, address1, address2, city, zip, state, dayPhone, eveningPhone) =>
  new Promise((resolve, reject) => {
    const user = {
      id: id,
      firstName: firstName,
      lastName: lastName,
      email: email,
      address1: address1,
      address2: address2,
      city: city,
      zip: zip,
      state: state,
      dayPhone: dayPhone,
      eveningPhone: eveningPhone,
    };
    axios({
      url: '/me',
      data: user,
      method: 'PATCH',
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

const setPassword = (currentPassword, newPassword) =>
  new Promise((resolve, reject) => {
    const data = {
      oldPassword: currentPassword,
      newPassword: newPassword,
    };
    axios({
      url: '/me/password',
      data: data,
      method: 'PUT',
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

const getOrders = (offset, limit) =>
  new Promise((resolve, reject) => {
    const params = {
      offset: offset,
      limit: limit,
    };
    axios({
      url: '/me/order',
      method: 'GET',
      params: params,
    })
      .then((resp) => {
        resolve(resp.data.items);
      })
      .catch((err) => {
        reject(err);
      });
  });

const getTransactions = (offset, limit) =>
  new Promise((resolve, reject) => {
    const params = {
      offset: offset,
      limit: limit,
    };
    axios({
      url: '/me/transaction',
      method: 'GET',
      params: params,
    })
      .then((resp) => {
        resolve(resp.data.items);
      })
      .catch((err) => {
        reject(err);
      });
  });

const getBonusPoints = () =>
  new Promise((resolve, reject) => {
    axios({
      url: '/me/bonusPoints',
      method: 'GET',
    })
      .then((resp) => {
        resolve(resp.data.points);
      })
      .catch((err) => {
        reject(err);
      });
  });

const orderBonus = (item) =>
  new Promise((resolve, reject) => {
    const data = {
      productId: item.productId,
      productVersionId: item.productVersionId,
    };
    axios({
      url: '/me/bonusPoints/order',
      data: data,
      method: 'POST',
    })
      .then((resp) => {
        const response = {
          isRequestValid: resp.data.isRequestValid,
          errorsArray: resp.data.errors,
          physicalProducts: resp.data.physicalProducts,
        };
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });

const getUserDetailsById = (user) =>
  new Promise((resolve, reject) => {
    axios({
      url: 'hr-adm/getuserdetails',
      params: user,
      method: 'GET',
    })
      .then((resp) => {
        console.log(resp, 'from user detail api');
        resolve(resp.data);
      })
      .catch((err) => {
        console.log('error while calling get user details api');
      });
  });

export { getMe, patchMe, setPassword, getOrders, getTransactions, getBonusPoints, orderBonus, getUserDetailsById, getAdminUser };
